var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxsStarBkg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs-star.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.947 9.17706C21.8842 8.99193 21.7685 8.82925 21.6142 8.70912C21.46 8.58899 21.2739 8.51666 21.079 8.50106L15.378 8.04806L12.911 2.58706C12.8325 2.41117 12.7047 2.26178 12.5431 2.15692C12.3815 2.05205 12.193 1.9962 12.0004 1.99609C11.8077 1.99599 11.6192 2.05164 11.4575 2.15632C11.2957 2.26101 11.1678 2.41026 11.089 2.58606L8.62203 8.04806L2.92103 8.50106C2.72948 8.51624 2.54636 8.58627 2.39358 8.70279C2.2408 8.81931 2.12482 8.97738 2.05952 9.15809C1.99422 9.3388 1.98236 9.53449 2.02537 9.72176C2.06838 9.90903 2.16443 10.0799 2.30203 10.2141L6.51503 14.3211L5.02503 20.7731C4.97978 20.9684 4.99428 21.1728 5.06665 21.3597C5.13901 21.5467 5.26589 21.7076 5.43083 21.8215C5.59577 21.9354 5.79115 21.9972 5.99161 21.9987C6.19208 22.0002 6.38837 21.9415 6.55503 21.8301L12 18.2001L17.445 21.8301C17.6154 21.9432 17.8162 22.0014 18.0207 21.9969C18.2251 21.9924 18.4232 21.9254 18.5884 21.805C18.7536 21.6845 18.878 21.5164 18.9448 21.3231C19.0116 21.1299 19.0176 20.9208 18.962 20.7241L17.133 14.3241L21.669 10.2421C21.966 9.97406 22.075 9.55606 21.947 9.17706Z",
    fill: "#EE9023"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsStarBkg);
export default __webpack_public_path__ + "static/media/bxs-star-bkg.a0d9c77e6581018fa88973d42b521b99.svg";
export { ForwardRef as ReactComponent };